<template>
  <div>
    <CCard class="bg-style2 mt-3">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem">
        <span class="font-weight-bold h6">
          <CIcon class="mr-2" v-if="icon" :name="icon" /> {{ caption }}
        </span>
      </CCardHeader>
      <CCardBody class="pt-0 pb-0">
        <CRow class="gy-3">
          <!-- Total Eligible Voters -->
          <CCol :xs="12" :sm="6" :lg="3">
            <CCallout color="info">
              <small class="text-muted">Total Eligible Voters</small><br>
              <strong class="h4">{{ totalAccounts }}</strong>
            </CCallout>
          </CCol>

          <!-- Total Who Voted -->
          <CCol :xs="12" :sm="6" :lg="3">
            <CCallout color="warning">
              <small class="text-muted">People Who Voted</small><br>
              <strong class="h4">{{ totalUniqueVoters }}</strong>
            </CCallout>
          </CCol>

          <!-- Total Candidates -->
          <CCol :xs="12" :sm="6" :lg="3">
            <CCallout color="danger">
              <small class="text-muted">Total Candidates</small><br>
              <strong class="h4">{{ totalCandidates }}</strong>
            </CCallout>
          </CCol>

          <!-- Voter Turnout -->
          <CCol :xs="12" :sm="6" :lg="3">
            <CCallout color="success">
              <small class="text-muted">Voter Turnout (%)</small><br>
              <strong class="h4">{{ voterTurnout }}%</strong>
            </CCallout>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import api from '@/service/api'
import { CIcon } from '@coreui/vue'

export default {
  name: 'dashboard',
  components: { CIcon },
  props: {
    icon: { type: String, default: 'cil-bell' },
    caption: { type: String, default: 'Dashboard' }
  },
  data() {
    return {
      totalAccounts: 0,
      totalVotes: 0,
      totalUniqueVoters: 0,
      totalCandidates: 0,
      voterTurnout: 0
    }
  },
  methods: {
    async onInit() {
      try {
        const [accRes, voteRes, candidateRes] = await Promise.all([
          api.members('get'),
          api.vote('getAll'),
          api.candidate('getCandidates')
        ])

        const accounts = accRes?.data?.data || []
        const votes = voteRes?.data?.data || []
        const candidates = candidateRes?.data?.data || []

        // ✅ Filter eligible voters (user or candidate roles)
        this.totalAccounts = accounts.filter(a =>
            ['user', 'candidate'].includes(a.role?.role_name)
        ).length

        // ✅ Unique voters (voted or abstained)
        const uniqueVoterIds = new Set(votes.map(v => v.people))
        this.totalUniqueVoters = uniqueVoterIds.size

        // ✅ Count votes only for candidates
        this.totalVotes = votes.filter(v => v.candidate !== null).length

        // ✅ Voter Turnout (%)
        this.voterTurnout = this.totalAccounts > 0
            ? ((this.totalUniqueVoters / this.totalAccounts) * 100).toFixed(2)
            : 0

        // ✅ Total candidates
        this.totalCandidates = candidates.length
      } catch (err) {
        console.error('[Dashboard Load Error]', err)
      }
    }
  },
  created() {
    this.onInit()
  }
}
</script>
